"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

var _customProps = require("../../../../../../utils/customProps");

var _appRedirect = _interopRequireDefault(require("../../../../../../utils/appRedirect"));

/**
 * Link is used in storyblok redirect to a href
 */
var Link = function Link(_ref) {
  var text = _ref.text,
      color = _ref.color,
      href = _ref.href,
      underline = _ref.underline,
      rootClass = _ref.rootClass,
      external = _ref.external;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var externalRedirect = function externalRedirect() {
    window.location.replace(href);
  };

  var internalRedirect = function internalRedirect() {
    (0, _appRedirect.default)(href);
  };

  var onClick = function onClick() {
    if (external) {
      return externalRedirect();
    }

    return internalRedirect(href);
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    _react.default.createElement(_core.Link, {
      className: styles.root,
      color: color,
      underline: underline,
      href: "#",
      onClick: onClick
    }, text)
  );
};

exports.Link = Link;
var _default = Link;
exports.default = _default;
Link.propTypes = {
  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop:
   'initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error'
   * The color of the component. It supports those theme colors that make sense for this component.
   * */
  color: function color(props, propName, componentName) {
    var validProps = ['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /*
  * mui prop:'none', 'hover', 'always'
  * underline text
  */
  underline: function underline(props, propName, componentName) {
    var validProps = ['none', 'hover', 'always'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /* url for redirect */
  href: _propTypes.default.string.isRequired,

  /* text to click on */
  text: _propTypes.default.string.isRequired,

  /**
   * if false will redirect to a page in the app and should use '/page-whatever'
   *
   *  if true will redirect to another site 'https://www.google.com/'
   * */
  external: _propTypes.default.bool
};
Link.defaultProps = {
  color: 'primary',
  underline: 'hover',
  rootClass: [],
  external: false
};